import React, { useState, Suspense } from "react";
import styled from "styled-components";

const ServiciosContainer = styled.section`
  padding: 80px 20px;
  background: #f7f9fc;
  text-align: center;
  color: #1a1a1a;
  font-family: 'Merriweather', serif;
`;

const Title = styled.h2`
  font-size: 3rem;
  color: #1d3557;
  margin-bottom: 50px;
`;

const ServicesGrid = styled.div`
  display: flex;
  justify-content: center;
  gap: 30px;
  flex-wrap: wrap;
  margin-bottom: 50px;
`;

const ServiceCard = styled.div`
  background: ${({ isSelected }) => (isSelected ? "#eaf4f7" : "#ffffff")};
  color: ${({ isSelected }) => (isSelected ? "#1d3557" : "#333")};
  padding: 25px;
  width: 270px;
  border-radius: 14px;
  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.05);
  text-align: center;
  transition: all 0.3s ease-in-out;
  cursor: pointer;
  border: ${({ isSelected }) => (isSelected ? "2px solid #3282a2" : "1px solid #e0e0e0")};

  &:hover {
    transform: translateY(-6px);
    box-shadow: 0px 12px 30px rgba(0, 0, 0, 0.08);
  }
`;

const ServiceTitle = styled.h3`
  font-size: 20px;
  font-weight: 700;
  color: ${({ isSelected }) => (isSelected ? "#22577a" : "#1d3557")};
  margin-bottom: 12px;
`;

const ServiceDescription = styled.p`
  font-size: 1rem;
  line-height: 1.6;
  color: #555;
`;

const MoreInfoButton = styled.button`
  background: ${({ isSelected }) => (isSelected ? "#22577a" : "#3282a2")};
  color: #fff;
  font-size: 1rem;
  padding: 10px 18px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  margin-top: 15px;
  font-weight: 600;
  transition: 0.3s ease;

  &:hover {
    background: ${({ isSelected }) => (isSelected ? "#183f5e" : "#2c6d8f")};
  }
`;

const ExpandedContainer = styled.div`
  display: ${({ isVisible }) => (isVisible ? "block" : "none")};
  text-align: center;
  padding: 40px;
  max-width: 900px;
  margin: 0 auto;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.07);
  color: #1a1a1a;
`;

const ExpandedTitle = styled.h2`
  font-size: 2.2rem;
  color: #1d3557;
  font-family: "Merriweather", serif;
  margin-bottom: 20px;
`;

const ExpandedImage = styled.img`
  width: 100%;
  max-width: 520px;
  height: auto;
  border-radius: 12px;
  margin: 25px 0;
  box-shadow: 0px 6px 20px rgba(0, 0, 0, 0.05);
`;

const ExpandedDescription = styled.p`
  font-size: 1.2rem;
  font-family: "Merriweather", serif;
  line-height: 1.8;
  color: #333;
`;

const Servicios = () => {
  const [selectedService, setSelectedService] = useState(0);

  const serviciosData = [
    {
      title: "Mediación Familiar",
      description: "Ayudamos a resolver conflictos familiares pacíficamente.",
      moreInfo: `Ofrecemos soluciones para divorcios, custodia de menores, pensión alimenticia y otros conflictos familiares
      sin necesidad de acudir a juicio, priorizando el bienestar de todas las partes.`,
      image: `${process.env.PUBLIC_URL}/images/Family.webp`,
    },
    {
      title: "Mediación Civil y Mercantil",
      description: "Resolvemos disputas contractuales y de arrendamiento.",
      moreInfo: `Nos especializamos en conflictos contractuales, problemas de arrendamiento y disputas entre proveedores y clientes.
      Nuestra mediación es rápida y efectiva.`,
      image: `${process.env.PUBLIC_URL}/images/Plane.webp`,
    },
    {
      title: "Mediación Laboral",
      description: "Facilitamos negociaciones entre empleados y empleadores.",
      moreInfo: `Ayudamos a resolver conflictos laborales como despidos, diferencias salariales y problemas internos,
      evitando demandas y mejorando la comunicación dentro de la empresa.`,
      image: `${process.env.PUBLIC_URL}/images/Client.webp`,
    },
    {
      title: "Mediación Comunitaria",
      description: "Solucionamos disputas vecinales y en comunidades.",
      moreInfo: `Facilitamos el diálogo en conflictos vecinales, administración de condominios y fraccionamientos,
      asegurando la armonía en la comunidad.`,
      image: `${process.env.PUBLIC_URL}/images/Neighbor.webp`,
    },
  ];

  return (
    <ServiciosContainer>
      <Title>Nuestros Servicios</Title>
      <ServicesGrid>
        {serviciosData.map((service, index) => (
          <ServiceCard
            key={index}
            isSelected={selectedService === index}
            onClick={() => setSelectedService(index)}
          >
            <ServiceTitle>{service.title}</ServiceTitle>
            <ServiceDescription>{service.description}</ServiceDescription>
            <MoreInfoButton
              isSelected={selectedService === index}
              onClick={(e) => {
                e.stopPropagation();
                setSelectedService(index);
              }}
            >
              Ver Más
            </MoreInfoButton>
          </ServiceCard>
        ))}
      </ServicesGrid>
      {selectedService !== null && (
        <ExpandedContainer isVisible={selectedService !== null}>
          <ExpandedTitle>{serviciosData[selectedService].title}</ExpandedTitle>
          <Suspense fallback={<div>Cargando imagen...</div>}>
            <ExpandedImage
              src={serviciosData[selectedService].image}
              alt={serviciosData[selectedService].title}
              loading="lazy"
            />
          </Suspense>
          <ExpandedDescription>
            {serviciosData[selectedService].moreInfo}
          </ExpandedDescription>
        </ExpandedContainer>
      )}
    </ServiciosContainer>
  );
};

export default Servicios;